export default __webpack_public_path__ + "static/media/loading.bdd7cee2.svg";